import {Injectable} from '@angular/core';
import {JwtService} from 'mclane-webauth-lib';

@Injectable({
    providedIn: 'root'
})
export class JwtServiceHelper {

    constructor(private _jwtService: JwtService) {
    }

    getDecodedJwt(token) {
        return this._jwtService.getJwt(token);
    }

    setJwt(token) {
        this._jwtService.setJwt(token);
    }

    setPreferredUserName(preferred_username: string) {
        this._jwtService.preferred_username = preferred_username;
    }

    getPreferredUserName(): string {
        return this._jwtService.preferred_username;
    }

    setRoles(roles: string[]) {
        this._jwtService.roles = roles;
    }

    getRoles(): string[] {
        return this._jwtService.roles;
    }

    getToken(): string {
        return this._jwtService.token;
    }

    setToken(token) {
        this._jwtService.token = token;
    }

}


